<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Customers</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Customers
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Customers</h4>
                    <div class="col-lg-3 col-md-4 col-sm-6 d-flex">
                        <download-excel
                            ref="exporter-csv"
                            v-show="false"
                            type="csv"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Customers_Report.csv'"
                        />
                        <download-excel
                            ref="exporter-xls"
                            v-show="false"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Customers_Report.xls'"
                        />
                        <a href="#" @click.prevent="exportTableData('admin.customers.index', {}, 'csv')" class="export-link">
                            <i class="fas fa-file-csv"></i> Export to CSV</a> | &nbsp;
                        <a href="#" @click.prevent="exportTableData('admin.customers.index', {}, 'xls')" class="export-link text-warning">
                            <i class="fa fa-file-excel-o"></i> Export to Excel</a>
                    </div>
                </div>

                <div class="card-body">
                    <form>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Name</label>
                                    <input name="search" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.name">
                                    <template v-if="errors.name">
                                        <small class="text-danger" v-for="error in errors.name">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Email</label>
                                    <input name="order_no" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.email">
                                    <template v-if="errors.email">
                                        <small class="text-danger" v-for="error in errors.email">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Phone Number</label>
                                    <input name="order_no" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.phone">
                                    <template v-if="errors.phone">
                                        <small class="text-danger" v-for="error in errors.phone">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Start Date</label>
                                    <date-time-field name="category" id="category" class="form-control form-control-sm" v-model="filters.start_date" bound="start"></date-time-field>
                                    <template v-if="errors.start_date">
                                        <small class="text-danger" v-for="error in errors.start_date">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-12 col-xs-12">
                                <div class="form-group">
                                    <label for="category">By End Date</label>
                                    <date-time-field name="category" id="category" class="form-control form-control-sm" v-model="filters.end_date" bound="end"></date-time-field>
                                    <template v-if="errors.end_date">
                                        <small class="text-danger" v-for="error in errors.end_date">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-12 mb-2">
                                <label>&nbsp;</label>
                                <br>
                                <button type="submit" @click.prevent="paginatedData"
                                        class="btn btn-primary glow mb-1 mb-sm-0">Apply Filter
                                </button>
                                <button type="reset" @click.prevent="resetFilters"
                                        class="btn btn-warning glow mb-1 mb-sm-0">
                                    Reset Filter
                                </button>
                            </div>
                        </div>
                    </form>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allCustomers"
                        ref="myTable"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a href="#"
                                   class="dropdown-item"
                                   @click.prevent="editCustomerModal(props.row.id, props.row.first_name, props.row.last_name, props.row.email, props.row.phone)">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </a>
                                <a :href="route('admin.customers.orders',props.row.id)" class="dropdown-item">
                                    <i class="feather icon-eye"></i>
                                    View Orders
                                </a>
                                <a :href="route('admin.transactions.index', {
                                        'user_id': props.row.id
                                    })" class="dropdown-item">
                                    <i class="feather icon-eye"></i>
                                    View Transactions
                                </a>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                                <a
                                    v-if="impersonateShow"
                                    href="#"
                                    class="dropdown-item text-danger"
                                    @click.prevent="impersonationAlert(props.row.id)"
                                >
                                    <i class="feather icon-user"></i>
                                    Impersonate User
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>

        <div class="modal fade edit-customer-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
             aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="editCustomer">
                        <div class="modal-header"><h4 id="myModalLabel1" class="modal-title">Edit Customer Details</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group"><label>Customer First Name</label>
                                <input type="text" required="required" v-model="customer.first_name"
                                       class="form-control">
                                <div v-if="customer.errors.first_name" class="text-danger text-small">
                                    {{ customer.errors.first_name }}
                                </div>
                            </div>

                            <div class="form-group"><label>Customer Last Name</label>
                                <input type="text" required="required" v-model="customer.last_name"
                                       class="form-control">
                                <div v-if="customer.errors.last_name" class="text-danger text-small">
                                    {{ customer.errors.last_name }}
                                </div>
                            </div>

                            <div class="form-group"><label>Customer Email</label>
                                <input type="text" required="required" v-model="customer.email"
                                       class="form-control">
                                <div v-if="customer.errors.email" class="text-danger text-small">
                                    {{ customer.errors.email }}
                                </div>
                            </div>

                            <div class="form-group"><label>Customer Phone Number</label>
                                <input type="text" required="required" v-model="customer.phone"
                                       class="form-control">
                                <div v-if="customer.errors.phone" class="text-danger text-small">
                                    {{ customer.errors.phone }}
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" :disabled="saving">
                                Save <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import TableExportMixin from "../../Shared/Mixins/TableExportMixin";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import {formatDateTime} from "../../utils";

export default {
    metaInfo: {title: 'Customers'},
    props: [
        'customers', 'can_impersonate',
    ],
    layout: Layout,
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        TableExportMixin,
    ],
    data() {
        return {
            customer: this.$inertia.form({
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
            }),
            filters: {},
            errors: {},
            isLoadingFilter: false,
            allCustomers: [],
            exportRows: [],
            impersonateShow: false,
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },

            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Customer First Name', field: 'first_name', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Customer Last Name', field: 'last_name', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Customer Phone Number', field: 'phone', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Customer Email', field: 'email', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Customer Balance', field: 'balance', thClass: 'text-center', tdClass: 'text-center', formatFn: this.formatFn},
                {label: 'Loyalty Points', field: 'loyalty_points', thClass: 'text-center', tdClass: 'text-center',},
                {label: 'Date of Birth', field: 'dob', thClass: 'text-center', tdClass: 'text-center',},
                {label: 'Gender', field: 'gender', thClass: 'text-center', tdClass: 'text-center',},
                {label: 'Signup Platform', field: 'platform', thClass: 'text-center', tdClass: 'text-center',},
                {label: 'Signup Datetime', field: 'created_at', thClass: 'text-center', tdClass: 'text-center', formatFn: formatDateTime},
                {label: 'Action', field: 'action', sortable: false, width: '70px', thClass: 'text-center', tdClass: 'text-center'},
            ],
            tableDataLoading: false,
            saving: false,
            isEditing: false,
        }
    },

    computed: {
        exportFields() {
            const fields = {};
            this.columns.forEach(x => {
                if (x.label !== 'action') fields[x.label] = x.field;
            });
            return fields;
        },
    },
    mounted() {
        this.allCustomers = this.customers.data;
        this.totalRecords = this.customers.total;
        this.impersonateShow = this.can_impersonate;
    },

    methods: {

        async editCustomerModal(id, first_name, last_name, email, phoneNumber) {
            this.customer.first_name = first_name;
            this.customer.last_name = last_name;
            this.customer.email = email;
            this.customer.phone = phoneNumber;
            this.isEditing = true;
            this.customer.id = id;
            $('.edit-customer-modal').modal('show');
        },
        async resetFilters() {
            for (let filter in this.filters) {
                this.filters[filter] = null;
            }
            await this.paginatedData();
        },
        async editCustomer() {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    console.log(this.$refs)
                    this.saving = false
                    this.$refs.myTable.reload();
                },
                onError: () => {
                    this.saving = false;
                }
            };

            await this.customer.put(route('admin.customers.update', this.customer.id), {...this.customer}, options);
            this.saving = false;
            $('.edit-customer-modal').modal('hide');
            await this.paginatedData();
        },

        async paginatedData() {
            try {
                let routeName = 'admin.customers.index';

                let response = await axios.get(route(routeName), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                        ...this.filters,
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allCustomers = response.data.data
            } catch (e) {
                console.log(e);
            }
        },

        async deleteCustomer(id) {
            this.$inertia.delete(route('admin.customers.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.paginatedData();
                }
            })
        },

        async impersonate(id) {
            try {
                const {data} = await axios.get(route('admin.customers.impersonate', id));
                window.open(data.data.url, "_blank");
            } catch (e) {
                this.$store.commit('notifier/showNotifier', {message: e.response.data.message, type: 'danger'});
            }
        },

        async impersonationAlert(userId) {
            const details = {
                title: "Are you sure you want to impersonate this customer?",
                text: "You won't be able to revert this!",
                confirmButtonText: "Yes, Impersonate"
            }
            await this.deleteAlert(details.title, details.text,   true, "#3085d6",  "#d33",  "Yes, impersonate!",) ? await this.impersonate(userId) : "";
        },

        async showAlert(customerId) {
            const details = {
                title: "Are you sure you want to delete this customer?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteCustomer(customerId) : "";
        },
        formatFn(value) {
            return '₦' + (value ?? 0);
        },
    }
}
</script>
